// Ambient deep-water motes behind the whole site, with gentle scroll/pointer parallax.
// Cheap by design: DPR 1, ~30 fps, paused while the tab is hidden, static under prefers-reduced-motion.
export function startAmbient() {
  const canvas = document.createElement("canvas");
  canvas.className = "ambient";
  canvas.setAttribute("aria-hidden", "true");
  document.body.prepend(canvas);
  const ctx = canvas.getContext("2d");
  const mq = matchMedia("(prefers-reduced-motion: reduce)");
  let w = 0;
  let h = 0;
  let motes = [];
  let px = 0;
  let py = 0;
  let tx = 0;
  let ty = 0;
  let last = 0;
  let raf = 0;

  const sprite = document.createElement("canvas");
  sprite.width = sprite.height = 32;
  {
    const s = sprite.getContext("2d");
    const g = s.createRadialGradient(16, 16, 0, 16, 16, 16);
    g.addColorStop(0, "rgba(200,255,255,1)");
    g.addColorStop(0.3, "rgba(0,229,255,0.55)");
    g.addColorStop(1, "rgba(0,229,255,0)");
    s.fillStyle = g;
    s.fillRect(0, 0, 32, 32);
  }

  function resize() {
    w = canvas.width = window.innerWidth;
    h = canvas.height = window.innerHeight;
    const n = Math.round(Math.min(70, (w * h) / 26000));
    motes = Array.from({ length: n }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      z: 0.2 + Math.random() * 0.8,
      p: Math.random() * Math.PI * 2,
      s: 2 + Math.random() * 5,
    }));
  }

  function draw(t) {
    ctx.clearRect(0, 0, w, h);
    const sy = window.scrollY;
    px += (tx - px) * 0.05;
    py += (ty - py) * 0.05;
    for (const m of motes) {
      const tw = 0.5 + 0.5 * Math.sin(t * 0.0012 + m.p);
      const x = (m.x + px * m.z * 18 + w) % w;
      const y = (((m.y - sy * m.z * 0.25 + py * m.z * 12) % h) + h) % h;
      ctx.globalAlpha = (0.08 + 0.3 * tw) * m.z;
      const s = m.s * m.z * 2;
      ctx.drawImage(sprite, x - s / 2, y - s / 2, s, s);
    }
    ctx.globalAlpha = 1;
  }

  function frame(t) {
    raf = 0;
    if (document.hidden || mq.matches) return;
    if (t - last >= 33) {
      const dt = Math.min(0.1, (t - last) / 1000);
      last = t;
      for (const m of motes) {
        m.y -= dt * 7 * m.z;
        m.x += Math.sin(t * 0.0003 + m.p) * dt * 3;
        if (m.y < -10) {
          m.y = h + 10;
          m.x = Math.random() * w;
        }
      }
      draw(t);
    }
    raf = requestAnimationFrame(frame);
  }

  const kick = () => {
    if (mq.matches) return draw(0);
    if (!raf && !document.hidden) raf = requestAnimationFrame(frame);
  };

  window.addEventListener("resize", () => {
    resize();
    draw(performance.now());
  });
  window.addEventListener(
    "pointermove",
    (e) => {
      tx = (e.clientX / w - 0.5) * 2;
      ty = (e.clientY / h - 0.5) * 2;
    },
    { passive: true }
  );
  window.addEventListener("scroll", () => mq.matches && draw(0), { passive: true });
  document.addEventListener("visibilitychange", kick);
  mq.addEventListener?.("change", kick);
  resize();
  draw(0);
  kick();
}
